const ISD_CODE_COUNTRIES = {
    "AF": 93,
    "XP": 1,
    "AL": 355,
    "AS": 1,
    "AD": 376,
    "AO": 244,
    "AI": 1,
    "AG": 1,
    "AR": 54,
    "AW": 297,
    "AU": 61,
    "AT": 43,
    "AZ": 994,
    "BS": 1,
    "BH": 973,
    "XB": 1,
    "BD": 880,
    "BB": 1,
    "BE": 32,
    "QQ": 1,
    "BZ": 501,
    "BJ": 229,
    "BM": 1,
    "BT": 975,
    "BO": 591,
    "BA": 387,
    "BW": 267,
    "BR": 55,
    "VG": 1,
    "BN": 673,
    "BG": 359,
    "BF": 226,
    "BI": 257,
    "KH": 855,
    "CM": 237,
    "CA": 1,
    "CV": 238,
    "KY": 1,
    "CF": 236,
    "TD": 235,
    "CL": 56,
    "CN": 86,
    "CO": 57,
    "KM": 269,
    "CD": 243,
    "CG": 242,
    "CK": 682,
    "CR": 506,
    "HR": 385,
    "QS": 1,
    "AN": 599,
    "CY": 357,
    "C2": 357,
    "CZ": 420,
    "DK": 45,
    "DJ": 253,
    "QV": 1,
    "DM": 1,
    "DO": 1,
    "TP": 670,
    "EC": 593,
    "EG": 20,
    "SV": 503,
    "GQ": 240,
    "ER": 291,
    "EE": 372,
    "ET": 251,
    "FK": 500,
    "FJ": 679,
    "FI": 358,
    "FR": 33,
    "GF": 594,
    "GA": 241,
    "GM": 220,
    "GE": 995,
    "DE": 49,
    "QO": 1,
    "GH": 233,
    "GI": 350,
    "GR": 30,
    "QZ": 1,
    "GD": 1,
    "GP": 590,
    "GU": 1,
    "XY": 1,
    "GT": 502,
    "GN": 224,
    "GW": 245,
    "GY": 592,
    "HT": 509,
    "HN": 504,
    "QR": 1,
    "HK": 852,
    "HU": 36,
    "IS": 354,
    "XM": 1,
    "IN": 91,
    "ID": 62,
    "IQ": 964,
    "QX": 1,
    "IE": 353,
    "IL": 972,
    "IT": 39,
    "QP": 1,
    "CI": 225,
    "JM": 1,
    "JP": 81,
    "QM": 1,
    "JO": 962,
    "KZ": 7,
    "KE": 254,
    "KR": 82,
    "QN": 1,
    "K1": 383,
    "XF": 1,
    "KW": 965,
    "QU": 1,
    "KG": 996,
    "AA": 1,
    "LA": 856,
    "LV": 371,
    "LB": 961,
    "LS": 266,
    "LR": 231,
    "LI": 423,
    "LT": 370,
    "LU": 352,
    "MO": 853,
    "MK": 389,
    "MG": 261,
    "MW": 265,
    "MY": 60,
    "MV": 960,
    "ML": 223,
    "MT": 356,
    "MH": 692,
    "MQ": 596,
    "MU": 230,
    "YT": 262,
    "MX": 52,
    "FM": 691,
    "MD": 373,
    "MN": 976,
    "ME": 382,
    "MS": 1,
    "MA": 212,
    "MZ": 258,
    "MM": 95,
    "NA": 264,
    "NR": 674,
    "NP": 977,
    "NL": 31,
    "QT": 1,
    "NZ": 64,
    "NI": 505,
    "NE": 227,
    "NG": 234,
    "NU": 683,
    "MP": 1,
    "NO": 47,
    "OM": 968,
    "PK": 92,
    "PW": 680,
    "PS": 970,
    "PA": 507,
    "PG": 675,
    "PY": 595,
    "PE": 51,
    "PH": 63,
    "PL": 48,
    "PT": 351,
    "XT": 1,
    "PR": 1,
    "QA": 974,
    "QY": 1,
    "RE": 262,
    "RO": 40,
    "XW": 1,
    "RW": 250,
    "BL": 590,
    "KN": 1,
    "LC": 1,
    "VC": 1,
    "XU": 1,
    "WS": 685,
    "SA": 966,
    "SN": 221,
    "YU": 381,
    "SC": 248,
    "SL": 232,
    "SG": 65,
    "SK": 421,
    "SI": 386,
    "SB": 677,
    "ZA": 27,
    "ES": 34,
    "AB": 1,
    "LK": 94,
    "S1": 599,
    "SD": 249,
    "SR": 597,
    "SE": 46,
    "CH": 41,
    "TW": 886,
    "TJ": 992,
    "TZ": 255,
    "TH": 66,
    "XV": 1,
    "TG": 228,
    "TO": 676,
    "TT": 1,
    "TN": 216,
    "TR": 90,
    "XN": 1,
    "TM": 993,
    "TC": 1,
    "TV": 688,
    "XE": 1,
    "UG": 256,
    "UA": 380,
    "AE": 971,
    "GB": 44,
    "QW": 1,
    "US": 1,
    "UY": 598,
    "UZ": 998,
    "VU": 678,
    "VE": 58,
    "VN": 84,
    "VI": 1,
    "YE": 967,
    "ZM": 260,
    "ZW": 263
}